const HomeIcon = ({ size = 22 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    className="thankyou-home-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#dropShadow)">
      <path
        d="M3 10.5L11 4L19 10.5"
        stroke="#1961f7"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M5 10V18C5 18.5523 5.44772 19 6 19H16C16.5523 19 17 18.5523 17 18V10"
        stroke="#3bbec7"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect x="9" y="13" width="4" height="4" rx="1.2" fill="#1961f7" />
    </g>
    <defs>
      <filter
        id="dropShadow"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#1961f744" />
      </filter>
    </defs>
  </svg>
);

export default HomeIcon;
